module.exports = __webpack_public_path__ + "img/anyUSDC.3b5972c1.svg";